import React from 'react';
import { Box, Button, Stack, Text } from '@chakra-ui/react';
import * as api from './aiPlanTextApi';
type Props = {
 page: api.TextHistoryPage | null; error: string; loading: boolean; disabled: boolean; offset: number;
 onRefresh: () => void; onPage: (offset: number) => void; onSelect: (ids: api.TextRequestIds) => void;
};
export const AiPlanTextHistory: React.FC<Props> = props => <Box borderTopWidth="1px" pt="4">
 <Stack spacing="3">
  <Text fontWeight="semibold">Minhas solicitações nesta filial</Text>
  <Text fontSize="sm">Histórico salvo no servidor para seu usuário e contrato. Consultar não reenvia a geração. Uma nova solicitação não encerra as anteriores.</Text>
  <Button size="sm" alignSelf="flex-start" variant="outline" isDisabled={props.disabled || props.loading} onClick={props.onRefresh}>Atualizar histórico</Button>
  {props.loading && <Text role="status">Carregando histórico...</Text>}
  {props.error && <Text role="alert">{props.error}</Text>}
  {props.page?.items.map(item => <Box key={item.callId} borderWidth="1px" borderRadius="md" p="3">
   <Text>{api.textStatuses[item.state]}</Text>
   <Text fontSize="sm">{new Date(item.createdAt).toLocaleString('pt-BR')}</Text>
   <Text fontSize="sm">{item.state === 'settled' ? 'Consumido: ' + api.textMoney(item.actualMicros || 0) : item.state === 'released' ? 'Reserva liberada' : 'Valor reservado: ' + api.textMoney(item.reservedMicros)}</Text>
   <Button mt="2" size="sm" variant="link" whiteSpace="normal" wordBreak="break-all" textAlign="left" isDisabled={props.disabled || props.loading} onClick={() => props.onSelect({ requestId: item.requestId, callId: item.callId })}>Consultar {item.callId}</Button>
  </Box>)}
  {props.page?.items.length === 0 && <Text>Nenhuma solicitação nesta página.</Text>}
  <Stack direction="row">
   {props.offset > 0 && <Button size="sm" isDisabled={props.disabled || props.loading} onClick={() => props.onPage(Math.max(0, props.offset - 50))}>Mais recentes</Button>}
   {props.page?.nextOffset != null && <Button size="sm" isDisabled={props.disabled || props.loading} onClick={() => props.onPage(props.page!.nextOffset!)}>Mais antigas</Button>}
  </Stack>
 </Stack>
</Box>;
